(function () {
  if (window.__varionReserveContactLoaded) return;
  window.__varionReserveContactLoaded = true;

  const STORAGE_KEY = 'varionWildlandsReserveList';
  const FLOW_FLAG_KEY = 'varionWildlandsReserveFlow';
  const STORAGE_COOKIE_KEY = 'varionWildlandsReserveListShared';
  const FLOW_COOKIE_KEY = 'varionWildlandsReserveFlowShared';
  const SUCCESS_STORAGE_KEY = 'varionWildlandsReserveSuccess';
  const FLOW_CLASS = 'is-varion-reserve-flow';
  const TIME_WINDOW_OPTIONS = [
    'Beginn des Tages circa 9 Uhr',
    'Zwischen 10 und 12 Uhr',
    'Zwischen 12 und 14 Uhr',
    'Zwischen 14 und 16 Uhr'
  ];
  const SUNDAY_EVENT_ROTATION = [
    'Airsoft-Piraten 18er',
    'Weekend Warrior 0,5 Joule'
  ];
  const SUNDAY_EVENT_ANCHOR_DATE = '2026-05-24';
  const WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;
  const PRICE_LOCALE = 'de-DE';
  const PRICE_SUFFIX = ' EUR';
  const DEFAULT_TAX_RATE = 19;
  const DRAFT_ORDER_MODE = true;
  const FALLBACK_TO_CONTACT_FORM = false;
  const DEFAULT_PROXY_BASE = '/apps/wildlands-reserve';
  const PAYMENT_METHODS = {
    online_invoice: {
      value: 'online_invoice',
      label: 'Online bezahlen',
      sendInvoice: true
    },
    cash_pickup: {
      value: 'cash_pickup',
      label: 'Barabholung',
      sendInvoice: false
    }
  };
  const PICKUP_LOCATION = {
    name: 'Wildlands Airsoft Olching',
    address: 'Beim Himmelreich 33, 82140 Olching'
  };

  function getProxyBase() {
    const configuredBase = String(window.VarionWildlandsReserveProxyBase || '').trim();
    return (configuredBase || DEFAULT_PROXY_BASE).replace(/\/$/, '');
  }

  function normalizeReserveEndpoint(value) {
    const configured = String(value || '').trim();
    if (!configured) {
      return String(window.VarionWildlandsReserveEndpoint || '').trim() || getProxyBase() + '/reserve';
    }

    if (/\/reserve(?:[/?#]|$)/.test(configured)) {
      return configured;
    }

    return configured.replace(/\/$/, '') + '/reserve';
  }

  function getSharedCookieSuffix() {
    const hostname = String((window.location && window.location.hostname) || '').toLowerCase();
    const isVarionHost = hostname === 'varion.company' || hostname.endsWith('.varion.company');
    const secure = window.location && window.location.protocol === 'https:' ? '; Secure' : '';
    return '; path=/; SameSite=Lax' + secure + (isVarionHost ? '; domain=.varion.company' : '');
  }

  function readCookieValue(name) {
    const encodedName = encodeURIComponent(name) + '=';
    const cookies = String(document.cookie || '').split(';');
    for (let index = 0; index < cookies.length; index += 1) {
      const entry = cookies[index].trim();
      if (entry.indexOf(encodedName) !== 0) continue;
      try {
        return decodeURIComponent(entry.slice(encodedName.length));
      } catch (error) {
        return entry.slice(encodedName.length);
      }
    }
    return '';
  }

  function writeCookieValue(name, value, maxAgeSeconds) {
    document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(String(value || '')) +
      '; max-age=' +
      String(maxAgeSeconds) +
      getSharedCookieSuffix();
  }

  function clearCookieValue(name) {
    document.cookie =
      encodeURIComponent(name) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + getSharedCookieSuffix();
  }

  function readList() {
    let raw = '';
    try {
      raw = window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      raw = '';
    }

    if (!raw) {
      raw = readCookieValue(STORAGE_COOKIE_KEY);
      if (raw) {
        try {
          window.localStorage.setItem(STORAGE_KEY, raw);
        } catch (error) {
          /* ignore */
        }
      }
    }

    try {
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function readFlowFlag() {
    try {
      if (window.localStorage.getItem(FLOW_FLAG_KEY) === '1') return true;
    } catch (error) {
      /* ignore */
    }

    return readCookieValue(FLOW_COOKIE_KEY) === '1';
  }

  function saveList(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* ignore */
    }

    if (items.length) {
      writeCookieValue(STORAGE_COOKIE_KEY, JSON.stringify(items), 60 * 60 * 6);
    } else {
      clearCookieValue(STORAGE_COOKIE_KEY);
      clearCookieValue(FLOW_COOKIE_KEY);
      try {
        window.localStorage.removeItem(FLOW_FLAG_KEY);
      } catch (error) {
        /* ignore */
      }
    }

    document.dispatchEvent(new CustomEvent('varion:reserve-list-force-refresh'));
  }

  function clearReserveState() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
      window.localStorage.removeItem(FLOW_FLAG_KEY);
    } catch (error) {
      /* ignore */
    }

    clearCookieValue(STORAGE_COOKIE_KEY);
    clearCookieValue(FLOW_COOKIE_KEY);
  }

  function saveSuccessData(data) {
    try {
      window.sessionStorage.setItem(SUCCESS_STORAGE_KEY, JSON.stringify(data || {}));
    } catch (error) {
      /* ignore */
    }
  }

  function readSuccessData() {
    try {
      const raw = window.sessionStorage.getItem(SUCCESS_STORAGE_KEY) || '';
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function clearSuccessData() {
    try {
      window.sessionStorage.removeItem(SUCCESS_STORAGE_KEY);
    } catch (error) {
      /* ignore */
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeStock(value) {
    const stock = Math.floor(Number(value || 0));
    return Number.isFinite(stock) && stock > 0 ? stock : 0;
  }

  function normalizePriceCents(value) {
    const cents = Math.round(Number(value || 0));
    return Number.isFinite(cents) && cents > 0 ? cents : 0;
  }

  function formatPriceFromCents(value) {
    const cents = normalizePriceCents(value);
    if (!cents) return '';
    return (
      new Intl.NumberFormat(PRICE_LOCALE, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100) + PRICE_SUFFIX
    );
  }

  function parsePriceTextToCents(value) {
    const text = String(value || '').trim();
    if (!text) return 0;

    const sanitized = text
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^\d.]/g, '');

    const amount = Number.parseFloat(sanitized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function getItemPriceCents(item) {
    return normalizePriceCents(item.priceCents) || parsePriceTextToCents(item.price);
  }

  function totalValueCents(items) {
    return items.reduce(function (sum, item) {
      return sum + getItemPriceCents(item) * Math.max(0, Number(item.quantity || 0));
    }, 0);
  }

  function taxAmountCentsFromGross(grossCents, taxRate) {
    const cents = normalizePriceCents(grossCents);
    const rate = Number(taxRate || DEFAULT_TAX_RATE);
    if (!cents || !Number.isFinite(rate) || rate <= 0) return 0;
    return Math.round(cents - cents / (1 + rate / 100));
  }

  function hasAddressValues(form) {
    return Array.prototype.some.call(
      form.querySelectorAll('[data-varion-reserve-address-field]'),
      function (field) {
        return String(field.value || '').trim() !== '';
      }
    );
  }

  function fieldHasValue(field) {
    if (!field) return false;

    const fieldType = String(field.type || '').toLowerCase();
    if (fieldType === 'checkbox' || fieldType === 'radio') {
      return Boolean(field.checked);
    }

    return String(field.value || '').trim() !== '';
  }

  function areFieldsCompleted(nodeList) {
    return Array.prototype.every.call(nodeList, fieldHasValue);
  }

  function totalCount(items) {
    return items.reduce(function (sum, item) {
      return sum + Math.max(0, Number(item.quantity || 0));
    }, 0);
  }

  function formatCount(count) {
    return count === 1 ? '1 Artikel' : count + ' Artikel';
  }

  function getProductQuantity(items, productId, exceptId) {
    return items.reduce(function (sum, item) {
      if (String(item.productId || '') !== String(productId || '')) return sum;
      if (exceptId && item.id === exceptId) return sum;
      return sum + Math.max(0, Number(item.quantity || 0));
    }, 0);
  }

  function getReserveText(items) {
    return items
      .map(function (item) {
        const variant =
          item.variantTitle && item.variantTitle !== 'Default Title'
            ? ' | ' + item.variantTitle
            : '';
        const price = item.price ? ' | Preis: ' + item.price : '';
        const stock = normalizeStock(item.stock);
        const stockText = stock ? ' | Wildlands-Bestand: ' + stock : '';
        return item.quantity + 'x ' + item.title + variant + price + stockText;
      })
      .join('\n');
  }

  function getFieldValue(form, selector) {
    const field = form.querySelector(selector);
    return field ? String(field.value || '').trim() : '';
  }

  function buildCustomerPayload(form) {
    return {
      firstName: getFieldValue(form, '#ContactForm-first-name'),
      lastName: getFieldValue(form, '#ContactForm-last-name'),
      email: getFieldValue(form, '#ContactForm-email'),
      phone: getFieldValue(form, '#ContactForm-phone'),
      address1: getFieldValue(form, '#ContactForm-address1'),
      zip: getFieldValue(form, '#ContactForm-postcode'),
      city: getFieldValue(form, '#ContactForm-city'),
      country: getFieldValue(form, '#ContactForm-country')
    };
  }

  function buildConsentPayload(form) {
    const termsConsent = form.querySelector('[data-varion-reserve-terms-consent]');
    const privacyConsent = form.querySelector('[data-varion-reserve-privacy-consent]');

    return {
      termsAccepted: Boolean(termsConsent && termsConsent.checked),
      privacyAccepted: Boolean(privacyConsent && privacyConsent.checked),
      acceptedAt: new Date().toISOString()
    };
  }

  function getReservePaymentMethod(form) {
    const selected = form.querySelector('[data-varion-reserve-payment-method]:checked');
    const key = selected ? String(selected.value || '').trim() : '';
    return PAYMENT_METHODS[key] || null;
  }

  function buildReserveRequest(form, items, options) {
    const pickupDay = form.querySelector('[data-varion-reserve-date]');
    const pickupWindow = form.querySelector('[data-varion-reserve-window]');
    const note = form.querySelector('[data-varion-reserve-comment]');
    const totalCents = totalValueCents(items);
    const paymentMethod = getReservePaymentMethod(form);
    const strictPaymentSelection = Boolean(options && options.strictPaymentSelection);

    if (!paymentMethod && strictPaymentSelection) {
      throw new Error('Bitte w\u00E4hle eine Zahlungsart aus.');
    }

    return {
      source: 'theme-contact-reserve',
      draftOrder: true,
      draftOrderMode: DRAFT_ORDER_MODE,
      customer: buildCustomerPayload(form),
      consents: buildConsentPayload(form),
      payment: {
        method: paymentMethod ? paymentMethod.value : '',
        label: paymentMethod ? paymentMethod.label : '',
        sendInvoice: paymentMethod ? paymentMethod.sendInvoice : false
      },
      reserve: {
        status: 'WILDLANDS_RESERVE_PENDING',
        pickupLocation: PICKUP_LOCATION,
        pickupDay: pickupDay ? pickupDay.value : '',
        pickupWindow: pickupWindow ? pickupWindow.value : '',
        note: note ? String(note.value || '').trim() : '',
        itemCount: totalCount(items),
        totalValueCents: totalCents,
        totalValueText: formatPriceFromCents(totalCents),
        fullCustomerDataRequired: true,
        generatedAt: new Date().toISOString(),
        items: items.map(function (item) {
          return {
            id: item.id,
            productId: item.productId,
            variantId: item.variantId,
            title: item.title,
            variantTitle: item.variantTitle || '',
            quantity: Number(item.quantity || 0),
            stock: normalizeStock(item.stock),
            price: item.price || '',
            priceCents: getItemPriceCents(item),
            url: item.url || ''
          };
        })
      }
    };
  }

  function buildStructuredPayload(items, form) {
    return JSON.stringify(buildReserveRequest(form, items));
  }

  function getPriceText(item) {
    const rawPrice = String(item.price || '').trim();
    if (rawPrice) return rawPrice;
    return formatPriceFromCents(item.priceCents);
  }

  function getDateOnlyUtc(date) {
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function getSundayEventName(date) {
    const anchorParts = SUNDAY_EVENT_ANCHOR_DATE.split('-').map(function (part) {
      return Number(part);
    });
    const anchorUtc = Date.UTC(anchorParts[0], anchorParts[1] - 1, anchorParts[2]);
    const targetUtc = getDateOnlyUtc(date);
    const weeksFromAnchor = Math.round((targetUtc - anchorUtc) / WEEK_IN_MS);
    const rotationIndex =
      ((weeksFromAnchor % SUNDAY_EVENT_ROTATION.length) + SUNDAY_EVENT_ROTATION.length) %
      SUNDAY_EVENT_ROTATION.length;

    return SUNDAY_EVENT_ROTATION[rotationIndex];
  }

  function getUpcomingSundayOptions(count) {
    const options = [];
    const now = new Date();
    const cursor = new Date(now);
    cursor.setHours(0, 0, 0, 0);

    const isSunday = now.getDay() === 0;
    const isBeforeCutoff = now.getHours() < 16;
    const daysUntilSunday = (7 - cursor.getDay()) % 7;
    const initialOffset = isSunday && isBeforeCutoff ? 0 : daysUntilSunday || 7;
    cursor.setDate(cursor.getDate() + initialOffset);

    const labelFormatter = new Intl.DateTimeFormat('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    for (let index = 0; index < count; index += 1) {
      const date = new Date(cursor);
      date.setDate(cursor.getDate() + index * 7);

      const formattedDate = labelFormatter.format(date);
      const eventName = getSundayEventName(date);
      const label = formattedDate + ' | ' + eventName;

      options.push({
        label: label,
        value: label
      });
    }

    return options;
  }

  function getProductJsonUrl(url) {
    if (!url) return '';

    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.pathname.replace(/\/$/, '') + '.js';
    } catch (error) {
      return '';
    }
  }

  function getVariantImage(productData, variant) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }

    if (productData && Array.isArray(productData.images) && productData.images.length) {
      return productData.images[0];
    }

    return '';
  }

  function hydrateReservationItems(form) {
    const items = readList();
    const requiresHydration = items.some(function (item) {
      return !String(item.price || '').trim() || !String(item.image || '').trim();
    });

    if (!requiresHydration) return;

    Promise.all(
      items.map(function (item) {
        const shouldHydratePrice = !String(item.price || '').trim();
        const shouldHydrateImage = !String(item.image || '').trim();

        if ((!shouldHydratePrice && !shouldHydrateImage) || !item.url) {
          return Promise.resolve(item);
        }

        const productJsonUrl = getProductJsonUrl(item.url);
        if (!productJsonUrl) return Promise.resolve(item);

        return window
          .fetch(productJsonUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('product-json-unavailable');
            return response.json();
          })
          .then(function (productData) {
            const nextItem = Object.assign({}, item);
            const variant =
              productData.variants &&
              productData.variants.find(function (entry) {
                return String(entry.id) === String(item.variantId || '');
              });

            if (shouldHydratePrice) {
              const variantPrice = variant && typeof variant.price !== 'undefined' ? variant.price : null;
              const productPrice =
                typeof productData.price !== 'undefined' ? productData.price : null;
              nextItem.priceCents = variantPrice !== null ? variantPrice : productPrice;
              nextItem.price = formatPriceFromCents(nextItem.priceCents);
            }

            if (shouldHydrateImage) {
              nextItem.image = getVariantImage(productData, variant) || nextItem.image || '';
            }

            return nextItem;
          })
          .catch(function () {
            return item;
          });
      })
    ).then(function (nextItems) {
      const hasChanges = nextItems.some(function (item, index) {
        return (
          String(item.price || '') !== String(items[index].price || '') ||
          String(item.image || '') !== String(items[index].image || '')
        );
      });

      if (!hasChanges) return;

      saveList(nextItems);
      syncSummaryAndFlow(form, nextItems);
    });
  }

  function populateSelect(select, options, placeholder, autoSelectFirst) {
    if (!select) return;

    const previousValue = String(select.value || '');
    const currentOptions = [placeholder]
      .concat(
        options.map(function (option) {
          return option.value;
        })
      )
      .join('|');

    if (select.getAttribute('data-varion-options') === currentOptions) {
      if (previousValue) return;
    }

    select.innerHTML =
      '<option value="">' + escapeHtml(placeholder) + '</option>' +
      options
        .map(function (option) {
          return (
            '<option value="' +
            escapeHtml(option.value) +
            '">' +
            escapeHtml(option.label) +
            '</option>'
          );
        })
        .join('');

    select.setAttribute('data-varion-options', currentOptions);

    if (previousValue && options.some(function (option) { return option.value === previousValue; })) {
      select.value = previousValue;
      return;
    }

    if (autoSelectFirst && options.length) {
      select.value = options[0].value;
    }
  }

  function buildSummaryMarkup(items) {
    const count = totalCount(items);
    const totalPrice = formatPriceFromCents(totalValueCents(items));
    const totalTax = formatPriceFromCents(
      taxAmountCentsFromGross(totalValueCents(items), DEFAULT_TAX_RATE)
    );

    return (
      '<div class="varion-reserve-contact__top">' +
      '<div>' +
      '<p class="varion-reserve-contact__eyebrow">Wildlands Reservierung</p>' +
      '<h2 class="varion-reserve-contact__title">Deine pers&ouml;nliche Reservierungsliste</h2>' +
      '<p class="varion-reserve-contact__sub">Pr&uuml;fe kurz deine Artikel, passe bei Bedarf die Menge an und sende danach direkt deine Reservierung ab.</p>' +
      '</div>' +
      '<div class="varion-reserve-contact__pills">' +
      '<span class="varion-reserve-contact__pill">' +
      escapeHtml(formatCount(count)) +
      '</span>' +
      '<span class="varion-reserve-contact__pill">' + escapeHtml(PICKUP_LOCATION.name) + '</span>' +
      '</div>' +
      '</div>' +
      '<div class="varion-reserve-contact__list">' +
      items
        .map(function (item) {
          const variant =
            item.variantTitle && item.variantTitle !== 'Default Title'
              ? '<p class="varion-reserve-contact__variant">' + escapeHtml(item.variantTitle) + '</p>'
              : '';
          const stock = normalizeStock(item.stock);
          const reservedElsewhere = getProductQuantity(items, item.productId, item.id);
          const maxForItem = stock ? Math.max(1, stock - reservedElsewhere) : Math.max(1, Number(item.quantity || 1));
          const price = getPriceText(item);
          const image = item.image
            ? '<img class="varion-reserve-contact__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">'
            : '<div class="varion-reserve-contact__image is-placeholder"></div>';
          const minusDisabled = Number(item.quantity || 0) <= 1 ? ' disabled' : '';
          const plusDisabled = stock && Number(item.quantity || 0) >= maxForItem ? ' disabled' : '';
          const stockLine = stock
            ? '<p class="varion-reserve-contact__stock-badge">Aktueller Wildlands-Bestand: ' + stock + '</p>'
            : '<p class="varion-reserve-contact__meta">Bestand wird nach Best&auml;tigung gepr&uuml;ft</p>';
          const priceLine = price
            ? '<div class="varion-reserve-contact__price" aria-label="Produktpreis">' + escapeHtml(price) + '</div>'
            : '';

          return (
            '<article class="varion-reserve-contact__item">' +
            '<div class="varion-reserve-contact__image-frame">' +
            image +
            '</div>' +
            '<div class="varion-reserve-contact__body">' +
            '<div class="varion-reserve-contact__copy">' +
            '<strong>' + escapeHtml(item.title) + '</strong>' +
            variant +
            stockLine +
            '</div>' +
            '<div class="varion-reserve-contact__aside">' +
            '<div class="varion-reserve-contact__aside-top">' +
            priceLine +
            '<button type="button" class="varion-reserve-contact__remove-icon" aria-label="Artikel entfernen" data-varion-contact-remove="' + escapeHtml(item.id) + '">&times;</button>' +
            '</div>' +
            '<div class="varion-reserve-contact__actions">' +
            '<div class="varion-reserve-contact__qty-label">Menge</div>' +
            '<div class="varion-reserve-contact__qty">' +
            '<button type="button" data-varion-contact-qty="-1" data-varion-contact-id="' + escapeHtml(item.id) + '"' + minusDisabled + '>-</button>' +
            '<span>' + Number(item.quantity || 0) + '</span>' +
            '<button type="button" data-varion-contact-qty="1" data-varion-contact-id="' + escapeHtml(item.id) + '"' + plusDisabled + '>+</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</article>'
          );
        })
        .join('') +
      '<div class="varion-reserve-contact__total-row">' +
      '<span>Gesamtpreis</span>' +
      '<strong>' + escapeHtml(totalPrice || '0,00 EUR') + '</strong>' +
      '</div>' +
      '<div class="varion-reserve-contact__tax-row">' +
      '<span>davon ' + DEFAULT_TAX_RATE + ' % MwSt.</span>' +
      '<strong>' + escapeHtml(totalTax || '0,00 EUR') + '</strong>' +
      '</div>' +
      '</div>'
    );
  }

  function formatRequestTimestamp(value) {
    const date = value ? new Date(value) : new Date();
    if (Number.isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }

  function buildSuccessMarkup(data) {
    const reservationId = String((data && data.reservationId) || '').trim() || '-';
    const pickupDay = String((data && data.pickupDay) || '').trim() || '-';
    const pickupWindow = String((data && data.pickupWindow) || '').trim() || '-';
    const email = String((data && data.customerEmail) || '').trim() || '-';
    const paymentMethod = String((data && data.paymentMethodLabel) || '').trim() || 'Reservierung';
    const requestedAt = formatRequestTimestamp(data && data.requestedAt);
    const paymentUrl = String((data && data.paymentUrl) || '').trim();

    return (
      '<p class="varion-reserve-success__eyebrow">Reservierung angelegt</p>' +
      '<h2 class="varion-reserve-success__title">Vielen Dank für Ihre Reservierung.</h2>' +
      '<p class="varion-reserve-success__copy">Ihre Anfrage ist jetzt bei uns eingegangen. Ihre Artikel sind für den gewählten Termin vorgemerkt. Sollte noch etwas zu klären sein, kontaktieren wir Sie direkt per E-Mail.</p>' +
      '<div class="varion-reserve-success__grid">' +
      '<div class="varion-reserve-success__card"><span class="varion-reserve-success__label">Reservierungs-ID</span><div class="varion-reserve-success__value">' + escapeHtml(reservationId) + '</div></div>' +
      '<div class="varion-reserve-success__card"><span class="varion-reserve-success__label">Reservierung angefragt am</span><div class="varion-reserve-success__value">' + escapeHtml(requestedAt || '-') + '</div></div>' +
      '<div class="varion-reserve-success__card"><span class="varion-reserve-success__label">Gewünschter Spieltag</span><div class="varion-reserve-success__value">' + escapeHtml(pickupDay) + '</div></div>' +
      '<div class="varion-reserve-success__card"><span class="varion-reserve-success__label">Bevorzugtes Zeitfenster</span><div class="varion-reserve-success__value">' + escapeHtml(pickupWindow) + '</div></div>' +
      '<div class="varion-reserve-success__card"><span class="varion-reserve-success__label">Abholung</span><div class="varion-reserve-success__value">' + escapeHtml(PICKUP_LOCATION.name) + '<br>' + escapeHtml(PICKUP_LOCATION.address) + '</div></div>' +
      '<div class="varion-reserve-success__card"><span class="varion-reserve-success__label">Kontakt bei Rückfragen</span><div class="varion-reserve-success__value">' + escapeHtml(email) + '<br>' + escapeHtml(paymentMethod) + '</div></div>' +
      '</div>' +
      '<div class="varion-reserve-success__actions">' +
      (paymentUrl
        ? '<a class="varion-reserve-success__button varion-reserve-success__button--primary" href="' + escapeHtml(paymentUrl) + '">Jetzt zur Zahlung</a>'
        : '') +
      '<a class="varion-reserve-success__button" href="/">Weiter shoppen</a>' +
      '</div>'
    );
  }

  function renderSuccessView(data) {
    const successMount = document.querySelector('[data-varion-reserve-success]');
    const summaryMount = document.querySelector('[data-varion-reserve-contact]');
    const flow = document.querySelector('[data-varion-reserve-flow]');
    const form = document.getElementById('ContactForm');
    const contactRoot = document.querySelector('[data-varion-contact-root]');
    const pageHeading = document.querySelector(
      '[data-varion-contact-root] .title, [data-varion-contact-root] .main-page-title'
    );

    if (contactRoot) {
      contactRoot.setAttribute('data-varion-reserve-active', 'true');
    }

    if (pageHeading) {
      pageHeading.textContent = 'Reservierung bestätigt';
    }

    if (summaryMount) {
      summaryMount.hidden = true;
      summaryMount.innerHTML = '';
    }

    if (flow) {
      flow.hidden = true;
    }

    if (form) {
      form.hidden = true;
    }

    if (successMount) {
      successMount.hidden = false;
      successMount.innerHTML = buildSuccessMarkup(data || {});
    }
  }

  function setText(node, text) {
    if (!node) return;
    node.textContent = text;
  }

  function showSubmitState(form, type, message) {
    const state = form.querySelector('[data-varion-reserve-submit-state]');
    if (!state) return;

    state.hidden = !message;
    state.className = 'varion-reserve-submit-state';

    if (!message) {
      state.textContent = '';
      return;
    }

    if (type) {
      state.classList.add('is-' + type);
    }

    state.textContent = message;
  }

  function syncHiddenFields(form, items) {
    const sourceField = form.querySelector('[data-varion-reserve-source-field]');
    const listField = form.querySelector('[data-varion-reserve-list-field]');
    const countField = form.querySelector('[data-varion-reserve-count-field]');
    const payloadField = form.querySelector('[data-varion-reserve-payload-field]');
    const statusField = form.querySelector('[data-varion-reserve-status-field]');
    const totalField = form.querySelector('[data-varion-reserve-total-field]');
    const thresholdField = form.querySelector('[data-varion-reserve-threshold-field]');
    const paymentField = form.querySelector('[data-varion-reserve-payment-field]');
    const totalCents = totalValueCents(items);
    const paymentMethod = getReservePaymentMethod(form);

    if (sourceField) sourceField.value = 'Wildlands Reservierung';
    if (listField) listField.value = getReserveText(items);
    if (countField) countField.value = String(totalCount(items));
    if (payloadField) payloadField.value = buildStructuredPayload(items, form);
    if (statusField) statusField.value = 'WILDLANDS_RESERVE_PENDING';
    if (totalField) totalField.value = formatPriceFromCents(totalCents);
    if (paymentField) paymentField.value = paymentMethod ? paymentMethod.label : '';
    if (thresholdField) thresholdField.value = 'ja';
  }

  function updatePaymentSelectionUi(form) {
    const paymentBlock = form.querySelector('[data-varion-reserve-payment-block]');
    const paymentOptions = form.querySelectorAll('.varion-reserve-flow__payment-option');
    const selected = form.querySelector('[data-varion-reserve-payment-method]:checked');

    paymentOptions.forEach(function (option) {
      const input = option.querySelector('[data-varion-reserve-payment-method]');
      option.classList.toggle('is-selected', Boolean(input && input.checked));
    });

    if (paymentBlock) {
      paymentBlock.classList.toggle('is-selection-required', !selected);
      paymentBlock.classList.toggle('is-selection-complete', Boolean(selected));
    }
  }

  function applyCustomerDataRules(form, items) {
    const amount = form.querySelector('[data-varion-reserve-total-amount]');
    const addressDetails = form.querySelector('[data-varion-reserve-address-details]');
    const reserveRequiredFields = form.querySelectorAll('[data-varion-reserve-required]');
    const addressFields = form.querySelectorAll('[data-varion-reserve-address-field]');
    const paymentFields = form.querySelectorAll('[data-varion-reserve-payment-method]');
    const submitButton = form.querySelector('[data-varion-reserve-submit]');
    const reserveDay = form.querySelector('[data-varion-reserve-date]');
    const reserveWindow = form.querySelector('[data-varion-reserve-window]');
    const paymentReady = Boolean(form.querySelector('[data-varion-reserve-payment-method]:checked'));

    if (amount) {
      amount.textContent = formatPriceFromCents(totalValueCents(items)) || '0,00 EUR';
    }

    reserveRequiredFields.forEach(function (field) {
      field.required = true;
      field.setAttribute('aria-required', 'true');
    });

    paymentFields.forEach(function (field) {
      field.required = true;
      field.setAttribute('aria-required', 'true');
    });

    addressFields.forEach(function (field) {
      field.required = true;
      field.setAttribute('aria-required', 'true');
    });

    if (addressDetails) {
      addressDetails.classList.add('is-required');
    }

    updatePaymentSelectionUi(form);

    if (submitButton) {
      const reserveRequiredReady = areFieldsCompleted(reserveRequiredFields);
      const addressReady = areFieldsCompleted(addressFields);
      const scheduleReady = fieldHasValue(reserveDay) && fieldHasValue(reserveWindow);
      submitButton.disabled =
        totalCount(items) === 0 || !reserveRequiredReady || !addressReady || !scheduleReady || !paymentReady;
      submitButton.classList.toggle('is-disabled', submitButton.disabled);
    }
  }

  function syncSummaryAndFlow(form, items) {
    const mount = document.querySelector('[data-varion-reserve-contact]');
    if (mount) {
      mount.hidden = false;
      mount.innerHTML = buildSummaryMarkup(items);
    }

    const flow = document.querySelector('[data-varion-reserve-flow]');
    if (flow) {
      flow.hidden = false;
      setText(
        flow.querySelector('[data-varion-reserve-item-count]'),
        formatCount(totalCount(items))
      );
    }

    syncHiddenFields(form, items);
    applyCustomerDataRules(form, items);

    const submitButton = form.querySelector('[data-varion-reserve-submit]');
    if (submitButton) {
      setText(submitButton, 'Reservierungsanfrage senden');
    }
  }

  function activateReserveFlow(form, items) {
    document.documentElement.classList.add(FLOW_CLASS);
    document.body.classList.add(FLOW_CLASS);

    const contactRoot = document.querySelector('[data-varion-contact-root]');
    if (contactRoot) {
      contactRoot.setAttribute('data-varion-reserve-active', 'true');
    }

    const subjectName = 'contact[Betreff]';
    let subject = form.querySelector('input[name="' + subjectName + '"]');
    if (!subject) {
      subject = document.createElement('input');
      subject.type = 'hidden';
      subject.name = subjectName;
      form.appendChild(subject);
    }
    subject.value = 'Wildlands Reservierungsanfrage';

    const pageHeading = document.querySelector(
      '[data-varion-contact-root] .title, [data-varion-contact-root] .main-page-title'
    );
    setText(pageHeading, 'Reservierungsanfrage f\u00fcr Wildlands');

    const reserveDay = form.querySelector('[data-varion-reserve-date]');
    const reserveWindow = form.querySelector('[data-varion-reserve-window]');
    const submitButton = form.querySelector('[data-varion-reserve-submit]');
    const reserveMount = document.querySelector('[data-varion-reserve-contact]');
    let reserveSubmissionInFlight = false;
    const getAuraEndpoint = function () {
      return normalizeReserveEndpoint(
        ((reserveMount && reserveMount.getAttribute('data-varion-aura-endpoint')) || '').trim() ||
          (window.VarionReserveAuraEndpoint || '').trim()
      );
    };

    function ensureReserveSelections() {
      populateSelect(
        reserveDay,
        getUpcomingSundayOptions(6),
        'Bitte Sonntag ausw\u00e4hlen',
        false
      );

      populateSelect(
        reserveWindow,
        TIME_WINDOW_OPTIONS.map(function (option) {
          return { label: option, value: option };
        }),
        'Bitte Zeitfenster ausw\u00e4hlen',
        false
      );
    }

    ensureReserveSelections();
    window.setTimeout(ensureReserveSelections, 40);
    window.setTimeout(ensureReserveSelections, 300);
    window.setTimeout(ensureReserveSelections, 1200);

    if (reserveDay) {
      reserveDay.required = true;
      reserveDay.setAttribute('aria-required', 'true');
      reserveDay.addEventListener('focus', ensureReserveSelections);
      reserveDay.addEventListener('mousedown', ensureReserveSelections);
      reserveDay.addEventListener('touchstart', ensureReserveSelections, { passive: true });
    }

    if (reserveWindow) {
      reserveWindow.required = true;
      reserveWindow.setAttribute('aria-required', 'true');
      reserveWindow.addEventListener('focus', ensureReserveSelections);
      reserveWindow.addEventListener('mousedown', ensureReserveSelections);
      reserveWindow.addEventListener('touchstart', ensureReserveSelections, { passive: true });
    }

    const body = form.querySelector('[data-varion-reserve-comment]');
    const bodyLabel = form.querySelector('label[for="ContactForm-body"]');
    if (body) {
      body.required = false;
      body.removeAttribute('aria-required');
      body.placeholder =
        'Zus\u00e4tzliche Hinweise f\u00fcr deine Abholung, zum Beispiel R\u00fcckrufwunsch, Besonderheiten oder mehrere Personen.';
      if (!String(body.value || '').trim()) {
        body.value = '';
      }
    }
    if (bodyLabel) {
      bodyLabel.textContent = 'Zus\u00e4tzliche Hinweise (optional)';
    }

    const phoneLabel = form.querySelector('label[for="ContactForm-phone"]');
    if (phoneLabel) {
      phoneLabel.textContent = 'Telefon f\u00fcr R\u00fcckfragen';
    }

    const phoneInput = form.querySelector('#ContactForm-phone');
    if (phoneInput) {
      phoneInput.placeholder = 'Telefon f\u00fcr R\u00fcckfragen';
    }

    form.querySelectorAll('[data-varion-reserve-only]').forEach(function (block) {
      block.hidden = false;
    });

    if (submitButton) {
      submitButton.type = 'button';
    }

    syncSummaryAndFlow(form, items);
    hydrateReservationItems(form);

    const summaryRoot = document.querySelector('[data-varion-reserve-contact]');
    if (summaryRoot && !summaryRoot.getAttribute('data-varion-bound')) {
      summaryRoot.setAttribute('data-varion-bound', 'true');
      summaryRoot.addEventListener('click', function (event) {
        const removeButton = event.target.closest('[data-varion-contact-remove]');
        if (removeButton) {
          const nextItems = readList().filter(function (item) {
            return item.id !== removeButton.getAttribute('data-varion-contact-remove');
          });
          saveList(nextItems);
          syncSummaryAndFlow(form, nextItems);
          return;
        }

        const qtyButton = event.target.closest('[data-varion-contact-qty]');
        if (!qtyButton) return;

        const id = qtyButton.getAttribute('data-varion-contact-id');
        const delta = Number(qtyButton.getAttribute('data-varion-contact-qty'));
        const nextItems = readList();
        const currentItem = nextItems.find(function (entry) {
          return entry.id === id;
        });

        if (!currentItem) return;

        const stock = normalizeStock(currentItem.stock);
        const requested = Number(currentItem.quantity || 1) + delta;
        const reservedElsewhere = getProductQuantity(nextItems, currentItem.productId, currentItem.id);
        const maxForItem = stock
          ? Math.max(1, stock - reservedElsewhere)
          : Math.max(1, requested);
        const nextQuantity = Math.max(1, Math.min(requested, maxForItem));

        currentItem.quantity = nextQuantity;
        saveList(nextItems);
        syncSummaryAndFlow(form, nextItems);
      });
    }

    function refreshFormRules() {
      const currentItems = readList();
      syncHiddenFields(form, currentItems);
      applyCustomerDataRules(form, currentItems);
    }

    form.addEventListener('input', refreshFormRules);
    form.addEventListener('change', refreshFormRules);

    form.querySelectorAll('[data-varion-reserve-address-field]').forEach(function (field) {
      field.addEventListener(
        'invalid',
        function () {
          const details = form.querySelector('[data-varion-reserve-address-details]');
          if (details) details.classList.add('is-required');
        },
        true
      );
    });

    function triggerReserveRequestDirect() {
      if (reserveSubmissionInFlight) {
        return false;
      }

      const currentItems = readList();
      syncHiddenFields(form, currentItems);
      applyCustomerDataRules(form, currentItems);
      const auraEndpoint = getAuraEndpoint();

      if (!auraEndpoint && !FALLBACK_TO_CONTACT_FORM) {
        showSubmitState(
          form,
          'error',
          'Der Draft-Order-Endpunkt fehlt. Ohne Backend-Verbindung kann keine Reservierung als Draft Order erstellt werden.'
        );
        return false;
      }

      if (!auraEndpoint) {
        showSubmitState(
          form,
          'error',
          'Das Reservierungs-Endpoint ist nicht gesetzt. Bitte Backend-/App-Konfiguration pr\u00FCfen.'
        );
        return false;
      }

      if (!submitButton || submitButton.disabled) {
        return false;
      }

      if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
        const details = form.querySelector('[data-varion-reserve-address-details]');
        if (details && hasAddressValues(form)) {
          details.classList.add('is-required');
        }
        return false;
      }

      const payload = buildReserveRequest(form, currentItems, {
        strictPaymentSelection: true
      });
      const paymentMethod = payload.payment;
      reserveSubmissionInFlight = true;
      submitButton.disabled = true;
      submitButton.classList.add('is-disabled');
      setText(submitButton, 'Reservierung wird erstellt...');
      showSubmitState(
        form,
        'loading',
        paymentMethod.sendInvoice
          ? 'Wir erstellen jetzt deine Reservierung und holen den Zahlungslink.'
          : 'Wir erstellen jetzt deine Reservierung zur Barabholung.'
      );

      const requestPayload = {
        sendInvoice: paymentMethod.sendInvoice,
        createDraftOrder: DRAFT_ORDER_MODE,
        payload: payload
      };

      window
        .fetch(auraEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestPayload)
        })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              if (!response.ok) {
                const message =
                  data && data.error
                    ? data.error
                    : 'Die Reservierung konnte gerade nicht erstellt werden.';
                throw new Error(message);
              }
              return data;
            });
        })
        .then(function (data) {
          const paymentUrl =
            (data && (data.paymentUrl || data.invoiceUrl || data.checkoutUrl)) || '';

          clearReserveState();
          document.dispatchEvent(new CustomEvent('varion:reserve-list-force-refresh'));
          saveSuccessData({
            reservationId: (data && data.reservationId) || '',
            pickupDay: payload.reserve.pickupDay,
            pickupWindow: payload.reserve.pickupWindow,
            customerEmail: payload.customer.email,
            paymentMethodLabel: paymentMethod.label,
            paymentUrl: paymentUrl,
            requestedAt: payload.reserve.generatedAt
          });

          const successUrl = new URL(window.location.href);
          successUrl.searchParams.delete('wildlands_reserve');
          successUrl.searchParams.set('wildlands_reserve_success', '1');
          window.location.href = successUrl.toString();
        })
        .catch(function (error) {
          reserveSubmissionInFlight = false;
          applyCustomerDataRules(form, currentItems);
          setText(submitButton, 'Reservierungsanfrage senden');
          showSubmitState(
            form,
            'error',
            error && error.message
              ? error.message
              : 'Die Reservierung konnte gerade nicht erstellt werden.'
          );
        });

      return false;
    }

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        triggerReserveRequestDirect();
        return false;
      },
      true
    );

    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      const target = event.target;
      const tagName = target && target.tagName ? target.tagName.toUpperCase() : '';
      if (tagName === 'TEXTAREA') return;
      event.preventDefault();
      triggerReserveRequestDirect();
    });

    if (submitButton) {
      submitButton.addEventListener('click', function (event) {
        event.preventDefault();
        triggerReserveRequestDirect();
      });
    }
  }

  function boot() {
    const params = new URLSearchParams(window.location.search);
    const isReserveFlow = params.get('wildlands_reserve') === '1';
    const isReserveSuccess = params.get('wildlands_reserve_success') === '1';
    const form = document.getElementById('ContactForm');

    if (!form) return;

    if (isReserveSuccess) {
      const successData = readSuccessData();
      if (successData) {
        renderSuccessView(successData);
        return;
      }
    }

    if (document.querySelector('.form-status.form-status-list')) {
      clearReserveState();
      document.dispatchEvent(new CustomEvent('varion:reserve-list-force-refresh'));
    }

    const items = readList();
    const hasFlowFlag = readFlowFlag();
    const shouldActivateReserveFlow = isReserveFlow || hasFlowFlag;

    if (!shouldActivateReserveFlow) return;

    if (!items.length) {
      clearReserveState();
      const referrer = String(document.referrer || '');
      const sameOriginReferrer =
        referrer && referrer.indexOf(window.location.origin) === 0 && referrer !== window.location.href;
      if (sameOriginReferrer) {
        window.location.replace(referrer);
        return;
      }
      window.location.replace('/');
      return;
    }

    activateReserveFlow(form, items);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
